import React from 'react';

import AnimatedFigure from './AnimatedFigure';

const Animation = ({ imagesArr, timelines, setTimelines }) => {
  return (
    <div className="relative animation-container">
      {imagesArr.map((imgages, indexOfArray) =>
        imgages.map((img, indexOfElem) => (
          <AnimatedFigure
            key={img.src}
            image={img.src}
            style={img.style}
            animationOptions={img.animationOptions}
            indexOfArray={indexOfArray}
            lengthOfArray={imgages.length}
            indexOfElem={indexOfElem}
            timelines={timelines}
            setTimelines={setTimelines}
          />
        )),
      )}
    </div>
  );
};

export default Animation;
